function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

export default function newDateFromString (dateString: string) {
  if (!isSafari())return new Date(dateString);

  // Safari cannot parse "YYYY-MM-DD HH:mm:ss ±HHMM", but it can parse "YYYY/MM/DD HH:mm:ss ±HHMM"
  return new Date(dateString.replace(/^(\d{4})-(\d{2})-(\d{2})/, "$1/$2/$3"));
};
